module.exports = __webpack_public_path__ + "img/sex_m.cff368d2.png";